import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import store from '@/store';
import axios from 'axios';
import { query, deepClone } from '@/utils';
import { superAdmins } from '@/utils/auth';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/loginHome',
            component: () => import('@/views/LoginHome.vue')
        },
        {
            path: '/',
            redirect: '/project'
        },
        {
            path: '/task/strategyMap',
            redirect: '/task/strategyMap/1'
        },
        {
            path: '/',
            component: () => import('@/views/Main.vue'),
            children: [
                {
                    path: '/403',
                    component: () => import('@/views/403.vue')
                },
                {
                    path: 'task',
                    name: 'task',
                    meta: {
                        title: '会议任务'
                    },
                    component: () => import('@/views/Task/index.vue'),
                    children: [
                        {
                            path: 'strategyMap/:id',
                            name: 'taskStrategyMap',
                            meta: {
                                title: '作战目标'
                            },
                            component: () => import('@/views/Task/strategyMap/index.vue')
                        },
                        {
                            path: 'strategyEchart/:id',
                            name: 'taskStrategyEchart',
                            meta: {
                                title: '地图关联任务'
                            },
                            component: () => import('@/views/Task/strategyMap/Echart/index.vue')
                        },
                        {
                            path: 'waitDeal',
                            name: 'taskWaitDeal',
                            meta: {
                                title: '待处理'
                            },
                            component: () => import('@/views/Task/waitDeal/index.vue')
                        },
                        {
                            path: 'waitDeal/:id',
                            name: 'taskWaitDealDetail',
                            meta: {
                                title: '任务详情'
                            },
                            component: () => import('@/views/Task/waitDeal/Detail/index.vue')
                        },
                        {
                            path: 'propose',
                            name: 'taskPropose',
                            meta: {
                                title: '发起'
                            },
                            component: () => import('@/views/Task/propose/index.vue')
                        },
                        {
                            path: 'lookView',
                            name: 'taskLookView',
                            meta: {
                                title: '查看'
                            },
                            component: () => import('@/views/Task/lookView/index.vue')
                        },
                        {
                            path: 'taskEchart',
                            name: 'taskEchart',
                            meta: {
                                title: '报表'
                            },
                            component: () => import('@/views/Task/taskEchart/index.vue')
                        }
                    ]
                },
                {
                    path: 'question',
                    name: 'question',
                    meta: {
                        title: '专项问题'
                    },
                    component: () => import('@/views/Question/index.vue'),
                    children: [
                        {
                            path: 'me',
                            name: 'quesMe',
                            meta: {
                                title: '参与'
                            },
                            component: () => import('@/views/Question/me/index.vue')
                        },
                        {
                            path: 'quesDetail/:id',
                            name: 'quesWaitDealDetail',
                            meta: {
                                title: '问题详情'
                            },
                            component: () => import('@/views/Question/quesDetail/index.vue')
                        },
                        {
                            path: 'propose',
                            name: 'quesPropose',
                            meta: {
                                title: '发起'
                            },
                            component: () => import('@/views/Question/propose/index.vue')
                        },
                        {
                            path: 'lookView',
                            name: 'quesLookView',
                            meta: {
                                title: '查看'
                            },
                            component: () => import('@/views/Question/lookView/index.vue')
                        },
                        {
                            path: 'quesEchart',
                            name: 'quesEchart',
                            meta: {
                                title: '报表'
                            },
                            component: () => import('@/views/Question/quesEchart/index.vue')
                        }
                    ]
                },
                // {
                //     path: 'pageHome',
                //     name: 'pageHome',
                //     meta: {
                //         title: '首页'
                //     },
                //     component: () => import('@/views/PageHome/index.vue')
                // },
                // {
                //     path: 'pageHome/:id',
                //     name: 'pageHomeDetail',
                //     meta: {
                //         title: '首页-任务详情'
                //     },
                //     component: () => import('@/views/PageHome/Detail/index.vue')
                // },
                // {
                //     path: 'pageHome/moreThing',
                //     name: 'moreThing',
                //     meta: {
                //         title: '首页-更多'
                //     },
                //     component: () => import('@/views/PageHome/MoreThing/index.vue')
                // },
                {
                    path: '/manage',
                    name: 'manage',
                    meta: {
                        title: '管理'
                    },
                    component: () => import('@/views/Manage/index.vue')
                },
                {
                    path: '/target',
                    name: 'target',
                    meta: {
                        title: '目标'
                    },
                    component: () => import('@/views/Target/index.vue')
                },
                {
                    path: '/project',
                    name: 'project',
                    meta: {
                        title: '项目'
                    },
                    component: () => import('@/views/Project/index.vue')
                },
                {
                    path: '/project/moreThing',
                    name: 'projectMoreThing',
                    meta: {
                        title: '所有风险'
                    },
                    component: () => import('@/views/Project/MoreThing/index.vue')
                },
                {
                    path: '/project/moreProject',
                    name: 'moreProject',
                    meta: {
                        title: '所有项目'
                    },
                    component: () => import('@/views/Project/MoreProject/index.vue')
                },
                {
                    path: '/project/moreObject',
                    name: 'moreObject',
                    meta: {
                        title: '能力目标'
                    },
                    component: () => import('@/views/Project/MoreObject/index.vue')
                },
                // {
                //     path: '/task',
                //     name: 'task',
                //     meta: {
                //         title: '任务'
                //     },
                //     component: () => import('@/views/Task/index.vue')
                // },
                {
                    path: '/setting',
                    name: 'setting',
                    meta: {
                        title: '设置'
                    },
                    component: () => import('@/views/Setting/index.vue')
                },
                {
                    path: '/budgetBoard',
                    name: 'budgetBoard',
                    meta: {
                        title: '预算'
                    },
                    component: () => import('@/views/Board/BudgetBoard/index.vue')
                },
                {
                    path: '/needsBoard',
                    name: 'needsBoard',
                    meta: {
                        title: '需求'
                    },
                    component: () => import('@/views/Board/NeedsBoard/index.vue')
                },
                {
                    path: '/warningBoard',
                    name: 'WarningBoard',
                    meta: {
                        title: '预警'
                    },
                    component: () => import('@/views/Board/WarningBoard/index.vue')
                },
                {
                    path: '/operateBoard',
                    name: 'OperateBoard',
                    meta: {
                        title: '运维'
                    },
                    component: () => import('@/views/Board/OperateBoard/index.vue')
                }
            ]
        }
    ]
});

// 确认权限
export const checkRightMenus = (routers, to) => {
    // 如果页面上的菜单不存在，则它的子菜单也没有权限
    // 例如：/data/operation 不存在，则/data/operation/1 也没有权限登入
    let hasRight = false;
    for (let i = 0; i < routers.length; i++) {
        if (to.path.includes(routers[i]?.url)) {
            hasRight = true;
            break;
        }
        if (routers[i]?.subMenuList) {
            if (!hasRight) { // hasRight一旦为true，停止遍历
                hasRight = checkRightMenus(routers[i].subMenuList, to);
            }
        }
    }
    return hasRight;
};

const jumpUrl = (to, next, data = {}) => {
    const menus = store.getters.menus;
    const urlParams = query();
    if (!['/loginHome', '/', '/403', '/404'].includes(to.path)) {
        store.dispatch('addRouteNav', {
            name: to.query.title || to.meta.title,
            url: to.path,
            matched: to.matched.map(it => {
                return {
                    meta: it.meta,
                    url: it.path
                };
            })
        });
    }
    const ticket = to.query?.['ticket'] || '';
    let isForbidToNew = false;
    // 只有吉利汽车数字化中心的人才有新老版本切换
    if (urlParams.version === '1' || localStorage.getItem('isForbidToNew') === '1') {
        const list = ['205_000006', '205_000032', '205_000033', '205_000034', '205_000073', '205_000158'];
        if (data?.user?.orgCode?.includes('065_') || list.includes(data?.user?.orgCode) || superAdmins.includes(data?.user?.empNo)) {
            isForbidToNew = true;
        }
    }
    if (isForbidToNew) {
        localStorage.setItem('isForbidToNew', 1);
    }
    if ((!isForbidToNew) && data?.isNewVersion) {
        return location.replace(`${location.origin}/indexV2/home`);
    }
    if (ticket) {
        next({ path: '/', replace: true });
        return;
    } else {
        next();
        return;
    }
    // if (['/404', '/403'].includes(to.path)) {
    //     next();
    //     return;
    // }
    // // 没有匹配到
    // if (to.matched.length === 0 && to.path !== '/') {
    //     next({
    //         path: '/403'
    //     });
    //     return;
    // }
    // if (to.path === '/') {
    //     sessionStorage.removeItem('clickMenu');
    //     next({
    //         path: menus[0]?.url
    //     });
    //     return;
    // }
    // // 以上所有的都没有匹配，走菜单遍历判断权限，所以建立子页面要根据菜单规则
    // if (!checkRightMenus(menus, to)) {
    //     next({
    //         path: '/403'
    //     });
    //     return;
    // }
    // next();
};

router.beforeEach(async(to, from, next) => {
    if (to.meta.title) {
        document.title = `${to.meta.title} `;
    }
    const cbsToken = to.query?.['cbs-token'] || '';
    const gcpToken = to.query?.['gcpToken'] || '';
    if (gcpToken || cbsToken) { // h5跳转携带cbs-token
        next();
    } else if (localStorage.getItem('gcpToken') || localStorage.getItem('authToken')) {
        if (!store.getters.userInfo) {
            store.dispatch('GetInfo').then((data) => {
                // 拉取user_info
                // 动态路由，拉取菜单
                // loadMenus(next, to);
                jumpUrl(to, next, data);
            });
        } else {
            jumpUrl(to, next);
        }
    } else {
        const token = to.query?.['cbs-token'] || '';
        const gcpToken = to.query?.['gcpToken'] || '';
        const ticket = to.query?.['ticket'] || '';
        const jumpUrl = to.query?.url || '/';
        if (gcpToken || token) {
            next();
        } else if (ticket) {
            const tenantCode = import.meta.env.VITE_TENANT_CODE;
            localStorage.setItem('ticket', ticket);
            const redirectUrl = to.query?.['redirectUrl'] || '';
            const backUrl = query(redirectUrl)?.url || jumpUrl;
            const res = await axios({
                method: 'get',
                baseURL: '/hundred-login',
                headers: { 'ticket': ticket },
                url: `/login/success`
            });
            localStorage.setItem('gcpToken', res.data.data);
            // 老的业务中台逻辑
            axios({
                method: 'get',
                baseURL: '/hundred-platform',
                url: `/auth/api/uc-cbs-token/exchange?tenantCode=${tenantCode}&ticket=${ticket}`
            }).then((res) => {
                localStorage.setItem('authToken', res.data.data);
                if (redirectUrl.includes('indexV2')) {
                    location.replace(`${backUrl}`);
                } else {
                    next({ path: backUrl, replace: true });
                }
            }).catch((error) => {
                console.error('老的业务中台逻辑:', error);
                if (redirectUrl.includes('indexV2')) {
                    location.replace(`${backUrl}`);
                } else {
                    next({ path: backUrl, replace: true });
                }
            });
        } else {
            store.dispatch('LogIn');
        }
    }
});

router.afterEach((to, from, next) => {
    setTimeout(() => {
        window.scrollTo(0, 0);
    });
    store.dispatch('delPageNavList');
    store.dispatch('changeTaskId', null);
});

export default router;
